'use strict';

const cashflow = require('./components/cashflow');
const variables = require('./components/variables');
const optimus = require('./optimus/optimus');

module.exports = {
  createCashflow: cashflow.create,
  optimus,
  variables,
};
